





























































































































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import { Popup, Picker, RadioGroup, Radio, TreeSelect } from 'nut';
import { SELECTION_BOX_POP_TYPE } from '@/constants/business';
import uploadPicture from '@/pages/personalCenter/personalInfo/uploadPicture.vue';
import closeIcon from './close.png';
import newCloseIcon from './close_new.png';
Vue.use(Popup);
Vue.use(Picker);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(TreeSelect);
@Component({
  components: {
    uploadPicture,
  },
})
export default class Index extends Vue {
  // 是否使用新关闭图标
  @Prop({ default: false }) useNewIcon!: boolean;
  // 是否隐藏
  @Prop({ default: false }) hide!: boolean;
  // 是否自定义 selection-box 内容
  @Prop({ default: false }) isCustomBox!: boolean;
  // 左边标题
  @Prop({ default: '' }) title!: string;
  // 选择的文字
  @PropSync('selectedWord') selectedWordSync!: string | number;
  // 选择的内容对应的id
  @PropSync('selectedId') selectedIdSync!: number;
  // 选择的内容对应的key值
  @Prop({ default: '' }) valueKey!: string;
  // 提示文字
  @Prop({ default: '' }) placeholder!: string;
  // 是否有箭头
  @Prop({ default: true }) isHasArrow!: boolean;
  // 是否显示叉号
  @Prop({ default: true }) isHasCloseIcon!: boolean;
  // 是否能点击
  @Prop({ default: true }) isCanClick!: boolean;
  // 是否展示弹窗header
  @Prop({ default: true }) isShowHeader!: boolean;
  // 弹窗标题
  @Prop({ default: '' }) popTitle!: string;
  /**  弹窗类型
   * - 0 单选框类型带叉号
   * - 1 picker带确定取消
   * - 2 cell带标题类型且带叉号
   * - 3 cell不带标题类型且带叉号
   * - 4 页面跳转选择
   * */
  @Prop({ default: 0 }) popType!: number;

  /**  弹窗数据类型
   * - 0 dataList：[number|string]
   * - 1 dataList：[number|string]
   *
   * - 2  dataList: [
            {
              title: '小学',
              gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级']
            }
        ]
   * - 3 dataList: [number|string]
   * */
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataList!: any;

  // picker默认下标
  @Prop({ default: 0 }) defaultIndex!: number;

  show = false;
  // picker当前选择的数据
  pickerCurrentChangeValue!: string | number;
  selectionBoxPopType = SELECTION_BOX_POP_TYPE;
  closeImg = '';

  provinceIndex: number = 0;
  cityId: string = '';

  get uploadPicture() {
    return uploadPicture;
  }

  get word() {
    const { selectedWordSync, placeholder } = this;
    return selectedWordSync || placeholder;
  }

  // 是否是cell类型弹窗
  get isCellPopType() {
    return [
      SELECTION_BOX_POP_TYPE.CELL_TITLE_POP,
      SELECTION_BOX_POP_TYPE.CELL_POP,
    ].includes(this.popType);
  }

  created() {
    this.closeImg = this.useNewIcon ? newCloseIcon : closeIcon;
  }

  @Watch('show')
  onShowChanged(val: boolean) {
    const evtType = val ? 'open' : 'close';
    this.$emit(evtType);
  }

  // 点击弹出选择弹窗或者跳转选择页面
  selectContent() {
    // 不需要点击
    if (!this.isCanClick) return;
    // 跳转选择页面
    if (this.popType === SELECTION_BOX_POP_TYPE.PAGE_JUMP) {
      this.$emit('pageJump');
      return;
    }
    this.show = true;
  }

  closePop() {
    this.show = false;
  }

  // 单选框点击事件
  radioClick(id: number) {
    this.selectedIdSync = id;
    this.$emit('updateInfo', { key: this.valueKey, id: id });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pickerChange(picker: any, values: string | number) {
    this.pickerCurrentChangeValue = values;
  }

  pickerConfirm() {
    const dataList = this.dataList;
    const selectedWordSync =
      this.pickerCurrentChangeValue || (dataList.length && dataList[0]);
    this.selectedIdSync = Number(selectedWordSync);
    this.selectedWordSync = selectedWordSync;
    this.closePop();
  }

  pickerCancel() {
    this.closePop();
  }

  // cell类型弹窗选择内容
  cellSelect(selectedWord: string, id: number) {
    this.selectedWordSync = selectedWord;
    this.selectedIdSync = id;
    console.log('cell selected:', this.dataList, {
      key: this.valueKey,
      id: id,
    });
    if (this.valueKey === 'location') {
      const value = {
        provinceName: this.dataList[this.provinceIndex].text,
        province: this.dataList[this.provinceIndex].id,
        cityName: selectedWord,
        city: id,
      };
      this.$emit('updateInfo', {
        key: this.valueKey,
        value,
      });
    } else {
      this.$emit('updateInfo', { key: this.valueKey, id: id });
    }
    this.closePop();
  }

  onClickNav(index: number) {
    this.provinceIndex = index;
  }

  onClickItem(item: any) {
    this.cityId = item.id;
    this.cellSelect(item.text, item.id);
  }
}
